import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Logo from "../Logo/Logo";
import sxStyles from "./Header.style";
const Header = ({ children, slots, logoToLink, linkComponent }) => (React.createElement(AppBar, { sx: (theme) => sxStyles(theme).appBar, position: "fixed" },
    React.createElement(Toolbar, { sx: (theme) => sxStyles(theme).toolbar, variant: "dense" },
        React.createElement(Box, { sx: (theme) => sxStyles(theme).wrapper },
            React.createElement(Box, { sx: (theme) => ({ ...sxStyles(theme).divider, ...sxStyles(theme).logo }) },
                React.createElement(Logo, { to: logoToLink, linkComponent: linkComponent })),
            slots?.middle && React.createElement(Box, { sx: (theme) => sxStyles(theme).divider }, slots.middle),
            React.createElement(Box, { sx: (theme) => ({ ...sxStyles(theme).divider, ...sxStyles(theme).content }) }, children)))));
export default Header;
//# sourceMappingURL=Header.js.map